import React from "react";
import Typewriter from "typewriter-effect";

export type AIResponseComponentProps = {
  aiResponse: string;
};

// dont need
// const truncateToWordLimit = (str: string, limit: number) => {
//   const words = str.split(/\s+/); // Split string into words
//   if (words.length > limit) {
//     return words.slice(0, limit).join(" ") + "..."; // Truncate and add ellipsis
//   }
//   return str;
// };

export const AIResponseComponent: React.FC<AIResponseComponentProps> = ({
  aiResponse,
}) => {
  return (
    <h1 className="text-lg text-hackerGreen font-bold mx-4 type-level1">
      <Typewriter
        key={aiResponse}
        onInit={(typewriter) => {
          typewriter.changeDelay(25).typeString(aiResponse).start();
        }}
      />
    </h1>
  );
};
